import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noDataOrder.png'


const _withScopeId = n => (_pushScopeId("data-v-7ce6dd12"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "orderBox"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "high" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "org" }
const _hoisted_8 = { class: "end" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "r" }
const _hoisted_11 = {
  key: 1,
  class: "noDataOrder"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "paging" }

import { ref, reactive, computed, watch } from "vue";
import { useStore } from "vuex";
import { queryOrderLists, queryServiceLists } from "@/api/userCenter";
import i18n from "@/lang";
import { zhEnConversion } from "@/utils";
import { OrderListType, OrderListResultType } from "@/types/userCenter";

export default /*#__PURE__*/_defineComponent({
  __name: 'ItemOrder',
  setup(__props) {

const store = useStore();
const isMobile = computed(() => !!store.state.isMobile);
const serviceMation = reactive({ list: [] });
const language = computed(() => store.state.appLanguage);
const $t = i18n.global.t;
const pageInfo = reactive({
  pageIndex: 1,
  pageSize: 10,
});
const orderTotal = ref(0);
const productId = ref("");
/**
 * 获取服务产品ID
 */
const queryProductId = () => {
  queryServiceLists().then((res) => {
    try {
      const data = res.data.productServiceVoList[0];
      productId.value = data.productId;
      store.commit("pay/setCurrentSurplusTime", data.currentSurplusTime);
      handlerPage();
    } catch (error) {}
  });
};

const languageSymbol = (currentType: string) => {
  return currentType === "CNY" ? "￥" : "$";
};
/**
 * 获取订单数据
 */
const handlerPage = () => {
  if (productId.value) {
    queryOrderLists({
      productId: productId.value,
      ...pageInfo,
    }).then((res: OrderListResultType) => {
      if (res.code === 0) {
        serviceMation.list = res.data.records.map((item: OrderListType) => {
          return Object.assign(item, {
            productName: `DEC  ${zhEnConversion(item.productName)} ${
              item.serviceTime || "-"
            } ${i18n.global.t("user_center.device_month_membership")}`,
            singleAmount: languageSymbol(item.currencyType) + item.singleAmount,
            orderAmount: languageSymbol(item.currencyType) + item.orderAmount,
          });
        });
        orderTotal.value = res.data.total;
      }
    });
  } else {
    queryProductId();
  }
};
watch(
  () => language.value,
  () => {
    handlerPage();
  }
);
handlerPage();
const remarkChange = (row) => {
  let remark = "";
  switch (row.preferenceType) {
    case 1:
      const discount =
        language.value === "zh"
          ? row.preferenceStrength / 10
          : 100 - row.preferenceStrength + "%";
      remark = $t("v_code.discount", {
        number: discount,
      });
      break;
    case 2:
      remark = i18n.global.t("v_code.per_device", {
        number: languageSymbol(row.currencyType) + row.preferenceStrength,
      });
      break;
    default:
      remark = $t("v_code.normal_price");
      break;
  }

  return remark;
};

return (_ctx: any,_cache: any) => {
  const _component_SecondPageHeader = _resolveComponent("SecondPageHeader")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_component_SecondPageHeader, {
          key: 0,
          title: _unref($t)('user_center.order_list'),
          toPath: "/userCenter"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['orderList', { mobileSize: _unref(isMobile) }])
    }, [
      (serviceMation.list.length != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  data: serviceMation.list,
                  style: {"width":"100%"},
                  stripe: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: _unref($t)('user_center.order_number'),
                      align: "center",
                      prop: "orderNum",
                      "show-overflow-tooltip": "",
                      width: "130"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _unref($t)('user_center.service_name'),
                      align: "center",
                      prop: "productName"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _unref($t)('user_center.price'),
                      align: "center",
                      prop: "singleAmount",
                      width: "100"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _unref($t)('user_center.amount'),
                      align: "center",
                      prop: "orderAmount",
                      width: "100"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _unref($t)('user_center.payment_time'),
                      align: "center",
                      prop: "payTime",
                      width: "180"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _unref($t)('user_center.remark'),
                      align: "center",
                      "show-overflow-tooltip": "",
                      width: "160"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(remarkChange(scope.row)), 1)
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["data"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serviceMation.list, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "cardBox",
                      key: index
                    }, [
                      _createElementVNode("div", {
                        class: "title",
                        textContent: _toDisplayString(_unref($t)('user_center.major_version'))
                      }, null, 8, _hoisted_3),
                      _createElementVNode("div", {
                        class: "sub",
                        textContent: _toDisplayString(item.orderNum)
                      }, null, 8, _hoisted_4),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", {
                          class: "gray",
                          textContent: _toDisplayString(remarkChange(item))
                        }, null, 8, _hoisted_6),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(item.orderAmount), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: "l",
                          textContent: _toDisplayString(item.payTime)
                        }, null, 8, _hoisted_9),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref($t)("user_center.price")) + "：" + _toDisplayString(item.singleAmount), 1)
                      ])
                    ]))
                  }), 128))
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", null, _toDisplayString(_unref($t)("user_center.not_order_info")), 1)
          ])),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "prev, pager, next",
          onSizeChange: handlerPage,
          onCurrentChange: handlerPage,
          "current-page": pageInfo.pageIndex,
          "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((pageInfo.pageIndex) = $event)),
          "hide-on-single-page": "",
          "page-size": pageInfo.pageSize,
          "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((pageInfo.pageSize) = $event)),
          total: orderTotal.value
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ], 2)
  ], 64))
}
}

})